export * from './FeedbackComponent'
